import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class NotificationService{

    constructor(){}
    notificationSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    pushNotification(data: any){
        this.notificationSubject.next(data)
    }
}